import { render, staticRenderFns } from "./PromotedPartners.vue?vue&type=template&id=93826cae&scoped=true"
import script from "./PromotedPartners.vue?vue&type=script&lang=js"
export * from "./PromotedPartners.vue?vue&type=script&lang=js"
import style0 from "./PromotedPartners.vue?vue&type=style&index=0&id=93826cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93826cae",
  null
  
)

export default component.exports